export const roundToTwo = (n: number) => Math.round(n * 100) / 100;

export function isValidCNPJ(cnpj: string): boolean {
  // Remove tudo que não for número
  const cleanCNPJ = cnpj.replace(/\D/g, '');

  if (cleanCNPJ.length !== 14) return false;

  // Elimina CNPJs com todos os dígitos iguais (ex: 00000000000000, 11111111111111)
  if (/^(\d)\1{13}$/.test(cleanCNPJ)) return false;

  const calcCheckDigit = (digits: string, pos: number[]): number => {
    const sum = digits
      .split('')
      .reduce((acc, digit, idx) => acc + parseInt(digit, 10) * pos[idx], 0);
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  const base = cleanCNPJ.slice(0, 12);
  const firstCheck = calcCheckDigit(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondCheck = calcCheckDigit(base + firstCheck, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

  return cleanCNPJ === base + firstCheck + secondCheck;
}

export function getFormattedDateTime(): string {
  const now = new Date();

  const pad = (num: number) => String(num).padStart(2, "0");

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1); // Mês começa em 0
  const year = now.getFullYear();

  const hours = pad(convertToGMT3(now.getHours()));
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
}

export function toReais(price: number): string {
  return `R$ ${(price ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatIsoToBrDatetime(isoString: string): string {
  const date = new Date(isoString);

  const pad = (n: number) => String(n).padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // meses começam do 0
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

/** Formato DD/MM/YYYY (somente data) */
export function formatIsoToBrDate(isoString?: string | null): string {
  if (!isoString) return "—";
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "—";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}

/** Formato DD/MM/AA HH:MM (ano com 2 dígitos, sem segundos) */
export function formatIsoToBrDateTimeShort(isoString: string): string {
  const date = new Date(isoString);
  const pad = (n: number) => String(n).padStart(2, "0");
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = String(date.getFullYear()).slice(-2);
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export const convertToGMT3 = (hour: number) => {
  return (hour + 24 - 3) % 24;
};

export const getHourFromString = (hour: string) => parseInt(hour.split(":")[0], 10);
